import SectionHeading from "./SectionHeading";
import { entryLines } from "@/mocks/home";

interface EntryLinesProps {
  notify: (message: string) => void;
}

export default function EntryLines({ notify }: EntryLinesProps) {
  return (
    <section id="entries" className="bg-background-50 py-14 md:py-20 px-4 md:px-10">
      <SectionHeading
        eyebrow="当前可用入口"
        title="线路状态一目了然，进不去就换下一条"
        desc="下面每一条都是经过核对的有效入口。主线路最快，备用线路更稳，手机用户优先走移动线路，总有一条能带你进去。"
      />

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
        {entryLines.map((line) => {
          const available = line.status === "available";
          return (
            <article
              key={line.code}
              className="group rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start gap-4">
                <span
                  className={`w-12 h-12 rounded-lg flex items-center justify-center font-heading text-xl font-bold shrink-0 ${
                    available
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-300 text-foreground-600"
                  }`}
                >
                  {line.code}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="text-base font-medium text-foreground-950">{line.name}</h3>
                    <span
                      className={`h-6 px-2 rounded-full text-xs font-medium inline-flex items-center gap-1 ${
                        available
                          ? "bg-primary-100 text-primary-700"
                          : "bg-accent-100 text-accent-800"
                      }`}
                    >
                      <span
                        className={`w-1.5 h-1.5 rounded-full ${
                          available ? "bg-primary-500 animate-pulse-dot" : "bg-accent-500"
                        }`}
                      />
                      {available ? "可用" : "维护中"}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{line.desc}</p>
                </div>
              </div>

              <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-map-pin-line" />
                  {line.region}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-speed-up-line" />
                  {line.latency}
                </span>
              </div>

              <div className="mt-5 flex flex-col sm:flex-row gap-2.5">
                <button
                  type="button"
                  onClick={() => notify(`${line.name} 地址已复制到剪贴板`)}
                  className="inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-file-copy-line" />
                  复制地址
                </button>
                <button
                  type="button"
                  onClick={() => notify(`正在为你打开 ${line.name}（新标签）`)}
                  className={`inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    available
                      ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                      : "bg-background-300 text-foreground-600 hover:bg-background-400"
                  }`}
                >
                  <i className="ri-external-link-line" />
                  立即进入
                </button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}